import { Country } from '@afterpay/types'

export const COUNTRIES_WITH_PAY_MONTHLY_DOCUMENTS: Country[] = [Country.US]
